import Vue from 'vue'
import dayjs from 'dayjs' // 时间转换
// import Cookie from 'js-cookie'
import ErrorStackParser from 'error-stack-parser'
// import axios from 'axios'
// import CryptoJS from 'crypto-js' // aes加解密

// AES加密
// const AESEncrypt = function (data) {
//   try {
//     const key = CryptoJS.enc.Utf8.parse('Y6F3S5GBHKUD7MAQ')
//     const srcs = CryptoJS.enc.Utf8.parse(data)
//     const jimi = CryptoJS.AES.encrypt(srcs, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
//     let miwen = jimi.toString()
//     if (miwen && miwen.includes(' ')) {
//       miwen = miwen.replace(/ /g, '+')
//     }
//     return miwen
//   } catch (e) {
//     return ''
//   }
// }

// AES解密
// const AESDecrypt = function (data) {
//   try {
//     const key = CryptoJS.enc.Utf8.parse('Y6F3S5GBHKUD7MAQ')
//     const jiami = CryptoJS.AES.decrypt(data, key, { mode: CryptoJS.mode.ECB, padding: CryptoJS.pad.Pkcs7 })
//     const mingwen = jiami.toString(CryptoJS.enc.Utf8)
//     return mingwen.toString()
//   } catch (e) {
//     return ''
//   }
// }

export const serverlog = function (err, route, store, $winstonLog, $cookies) {
  // 服务端日志
  try {
    const mttime = dayjs()
    const usergetCountry = store.state.myCountry
    const province = store.state.curProvince
    const city = store.state.curCity
    const host = store.state.host
    const ip = store.state.userIp
    let bfp = $cookies.get('wiki-bfp')
    if (!bfp) {
      bfp = store.state.bfp
    }
    const msg = `${mttime.format('YYYY-MM-DD HH:mm:ss.SSS')} ERROR [DATA-API-WEB]:{"Function":"asyncData中的异常","页面Url":"//${host}${route.fullPath}","CountryCode":"${store.state.CountryCode}","LanguageCode":"${store.state.LanguageCode}","ip":"${ip}","国家":"${usergetCountry}","province":"${province}","city":"${city}","指纹":"${bfp}","HttpType":"","HttpState":"","Time":0,"Parameter":"","Message":"${err}","WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
    // console.log('serverlog', msg)
    $winstonLog.info(msg)
  } catch (err) {
    console.log('写日志的异常', err)
  }
}

const fxlog = function (mes, pageurl, lan, type, loglevel) {
  // try {
  //   if (!lan) {
  //     lan = Cookie.get('LanguageCode')
  //   }
  //   if (!pageurl) {
  //     pageurl = window.location.href
  //   }
  //   if (pageurl && (pageurl.includes('/upload-v1') || (mes.includes('base64') && mes.includes('ext')))) {
  //     const userAgent = navigator.userAgent
  //     const isIE = userAgent && userAgent.includes('compatible') && userAgent.includes('MSIE')
  //     if ((isIE && mes.length > 2000) || mes.length > 8000) {
  //       return
  //     }
  //   }
  //   const LanguageCode = (lan || 'zh-cn')
  //   let bpf = Cookie.get('wiki-bfp')
  //   if (!bpf) {
  //     bpf = '822ca7b3261a0b2ec10c8cdabfb5a0ea'
  //   }
  //   const mttime = new Date(dayjs()).getTime()
  //   const token = AESEncrypt(bpf + mttime)
  //   const headerToken = AESEncrypt(LanguageCode + mttime)
  //   // 设置请求超时的时间
  //   const islocalhost = process.env.NODE_ENV == 'development' && (window.location.host.includes('192.168.'))
  //   axios.post(`${islocalhost ? 'http' : 'https'}://log.fx696.com${islocalhost ? ':36911' : ''}/api/log`, {
  //     url: pageurl,
  //     message: mes,
  //     logtype: type,
  //     level: loglevel,
  //     timestamp: mttime,
  //     zhiwen: bpf,
  //     Country: Cookie.get('CountryCode'),
  //     Language: LanguageCode,
  //     logtoken: token
  //   }, {
  //     headers: {
  //       'Content-Type': 'application/json;charset=utf-8',
  //       'log-header-token': headerToken
  //     },
  //     timeout: 15000,
  //     retry: 0
  //   })
  // } catch (err) {
  //   console.log(err)
  // }
}

Vue.prototype.$fxlog = fxlog

const errorHandler = function (err, vm, info) {
  console.log('Vue.config.errorHandler', err, vm && vm.$route && vm.$route.fullPath, info)
  try {
    const param = {
      time: new Date(), // 请求时间
      level: 'jsError', // 报错等级info-严重；warn-警告
      type: 'javascript',
      message: err && err.message, // 报错内容
      page: vm && vm.$route && vm.$route.fullPath,
      hook: info,
      CountryCode: vm && vm.$store && vm.$store.state && vm.$store.state.CountryCode, // header国家
      LanguageCode: vm && vm.$store && vm.$store.state && vm.$store.state.LanguageCode, // headers语言
      myCountry: vm && vm.$store && vm.$store.state && vm.$store.state.myCountry,
      province: vm && vm.$store && vm.$store.state.curProvince,
      city: vm && vm.$store && vm.$store.state.curCity,
      host: vm && vm.$store && vm.$store.state.host,
      ip: vm && vm.$store && vm.$store.state.userIp
    }

    const mttime = dayjs()
    let errStack = ''
    if (!err.isAxiosError) {
      const errstackJson = ErrorStackParser.parse(err)[0]
      if (errstackJson) {
        errStack = decodeURIComponent(JSON.stringify(errstackJson))
      }
    }

    const errType = 'js全局异常'
    const userAgent = navigator && navigator.userAgent ? navigator.userAgent : ''
    const msg = `${mttime.format('YYYY-MM-DD HH:mm:ss.SSS')} ERROR [DATA-API-WEB]:{"Function":"${errType}","Url":"${param.page}","err":"${err}","info":"${JSON.stringify(param)}","Message":${err.message},"errorStack":"${errStack}","浏览器":"${userAgent}","WikiRequestId":"${mttime.format('YYYYMMDDHHmmssSSS')}${(Math.random() * 899999).toString().replace('.', '')}"}`
    if (param.page && !param.page.includes('/api/log')) {
      console.log(msg)
      // fxlog(msg, param.page, param.LanguageCode, '1')
    }
  } catch (err) {}
}

// Vue.config.errorHandler = errorHandler
Vue.prototype.$throw = (error, vm, info) => errorHandler(error, vm, info)

export default ({ store, route, $cookies, $winstonLog }, inject) => {
  inject('serverlog', (err) => {
    serverlog(err, route, store, $winstonLog, $cookies)
  })
}
